import { connect } from 'react-redux';
import LoginPage from './LoginPage';
import { onFieldChange, login, resetPage, showLoginForm } from '../../actions/LoginPage';

const mapsStateToProps = state => ({
	loginPageProps: state.loginPageReducer
});

const mapsDispatchToProps = dispatch => ({
	onFieldChange(fieldName, fieldValue) {
		dispatch(onFieldChange(fieldName, fieldValue));
	},
	login(opts) {
		dispatch(login(opts));
	},
	resetPage() {
		dispatch(resetPage());
	},
	showLoginForm(opts) {
		dispatch(showLoginForm(opts));
	}
});

export default connect(
	mapsStateToProps,
	mapsDispatchToProps
)(LoginPage);
